import * as z from "zod";
import { ShopperAgentConfigVersionMetaSchema } from "./shopper-agent-config-version-meta";

/** Current draft + published config versions (null draft = no unpublished edits). */
export const getShopperAgentConfigState = {
  name: "getShopperAgentConfigState" as const,
  input: z.object({}),
  output: z.object({
    // False until the team's settings surface is CRDB-backed (read flag on).
    versioningActive: z.boolean(),
    draft: ShopperAgentConfigVersionMetaSchema.nullable(),
    published: ShopperAgentConfigVersionMetaSchema.nullable(),
  }),
};
